<template>
  <div class="form" style="text-align:left;">
    <div class="title is-4">{{ title }}</div>


    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Name">
          <b-input maxlength="255" v-model="item.name"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Spielart">
          <multiselect v-model="item.category" :show-labels="false" placeholder="Spielart auswählen"
            :options="categories" :multiple="false" track-by="id" label="name" :close-on-select="true"></multiselect>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column" style="text-align:left;">
        <label class="label">Beschreibung</label>
        <VueTrix maxlength="255" v-model="item.description" placeholder="Beschreibung einfügen" />
      </div>
    </div>

    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Bild">
          <b-input maxlength="255" v-model="item.image"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Code">
          <b-input maxlength="255" v-model="item.code"></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="smallEditionUrl">
          <b-input maxlength="255" v-model="item.smallEditionUrl"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Sortierung">
          <b-numberinput v-model="item.frontendorder"></b-numberinput>
        </b-field>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <b-field label="Drucktext">
          <b-input maxlength="32" v-model="item.druckText"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Spieltyp">
          <multiselect v-model="item.gametype" :show-labels="false" placeholder="Spieltyp auswählen"
            :options="gameType" :multiple="false" :close-on-select="true"></multiselect>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column" style="text-align:right;">
        <b-button type="is-primary" v-on:click="save()" :disabled="loading">Speichern</b-button>
      </div>
    </div>

  </div>
</template>


<script>
import Multiselect from 'vue-multiselect'
import VueTrix from "vue-trix";

const axios = require('axios');


export default {
  name: "home",
  components: {
    Multiselect,
    VueTrix
  },
  data() {
    return {
      title: "Neues Spiel anlegen",
      loading: true,
      item: {
        category: {
          id: 1,
        },
        name: "",
        description: "",
        image: "",
        code: "",
        smallEditionUrl: "",
        druckText: "4/4-farbig (CMYK-Farben)",
      },
      categories: [],
      gameType: ["Standard","Klassiker"]
      //  item: { 'id': 22, 'name': 'Beidseitig individuelles Kartenset', 'spielart': 'Kartenspiel', 'date': '2016-10-15 13:43:27' },
    }
  },
  watch: {

  },
  mounted: function () {
    console.log("FORM " + this.$route.params.id);
    this.getCategories();

  },
  methods: {
    getCategories: function () {
      var _this = this;
      axios.get('/api/categories', {
        withCredentials: true,
      })
        .then(function (response) {
          console.log(response.data);
          _this.categories = response.data;

          if (_this.$route.params.id) {
            _this.getGame();
          } else {
            _this.item.category = _this.categories[0];
            _this.loading = false;
          }
          //_this.newGame.category = _this.categories[0];
          //_this.loading = false;
        })
        .catch(function (error) {
          console.log(error);
          //  _this.loading = false;
        })
        .then(function () {
          // always executed
        });
    },
    getGame: function () {
      this.title = "Spiel bearbeiten";
      //Get-Game
      var _this = this;
      axios.get('/api/games/' + this.$route.params.id, {
        withCredentials: true,
      })
        .then(function (response) {
          console.log(response.data);
          _this.item = response.data;
          _this.loading = false;

        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
          // always executed
        });
    },
    save: function () {
      if ((this.item.name) && (this.item.description) && (this.item.category) && (this.item.image) 
      && (this.item.code) && (this.item.smallEditionUrl)  && (this.item.gametype)) {

        //Set-Package
        var _this = this;
        var url = '/api/games';


        console.log("SAVE");
        console.log(url);
        console.log(this.item);

        axios.post(url, this.item, {
          headers: {
            'Content-Type': 'application/json',
          },
          withCredentials: true,
        })
          .then(function (response) {
            console.log(response.data);
            _this.$router.push({ name: 'games' })
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
            // always executed
          });

      } else {
        console.log("Alle Felder ausfüllen");
        this.$buefy.dialog.alert({
          title: 'Fehler',
          message: 'Bitte füllen Sie alle Felder aus.',
          type: 'is-danger',
          hasIcon: true,
          icon: 'alert-circle',
          iconPack: 'mdi'
        });

      }

    }
  }
};

</script>
